// activity-log-search-bar.config.ts

import { ActivityLogSearchBar } from "../../../models/activity-log-search.intercafe";
import {
  ContainerActivityLogComponent
} from "../../inventory/container/container-activity-log/container-activity-log.component";
import { REPLACE_KEY } from "../../../constants/app-constants";

export const ActivityLogSearchBarConfig: ActivityLogSearchBar = {
  CONTAINER: {
    dynamicFormConfig: {
      formRows: [
        {
          formGroups: [
            {
              style: { gridColumn: 'span 12' },
              control: {
                label: 'searchBar',
                skipLabel: true,
                displayLabel: 'Select Container',
                disabled: false,
                placeHolder: 'Select Container',
                returnRawValue: false,
                fieldInfo: {
                  dataType: 'picklist',
                  lookupDetails: {
                    apiUrl: 'v1/containers/list',
                    filterByKeys: ['CONTAINER_NO_CONTAINS'],
                    additionalFilters: [],
                    limit: 10,
                    orderBy: { modifiedDate: 'desc' },
                    bindLabel: 'containerNo',
                    bindValue: 'id',
                    displayColumns: [
                      { key: 'containerNo', header: 'Container Number' }
                    ]
                  }
                },
                validators: [{ type: 'required', message: '' }]
              }
            }
          ]
        }
      ]
    },
    preSetFilter: {
      name: 'CONTAINER_NO_CONTAINS',
      alias: 'CONTAINER_NO_CONTAINS',
      operator: 'CONTAINS',
      value: ['']
    },
    viewMode: 'modal',
    modalConfig: {
      component: ContainerActivityLogComponent,
      dataKey: 'containerId',
      title: "Container Activity Log"
    }
  },

  SHIPPING_BILL_NUMBER: {
    dynamicFormConfig: {
      formRows: [
        {
          formGroups: [
            {
              style: { gridColumn: 'span 12' },
              control: {
                label: 'searchBar',
                skipLabel: true,
                displayLabel: 'Select Shipping Bill No.',
                disabled: false,
                placeHolder: 'Select Shipping Bill No.',
                returnRawValue: false,
                fieldInfo: {
                  dataType: 'picklist',
                  lookupDetails: {
                    apiUrl: 'v1/items/list',
                    filterByKeys: ['DOCUMENT_NO_CONTAINS'],
                    additionalFilters: [
                      {
                        name: 'DOCUMENT_TYPE_EQUALS',
                        alias: 'DOCUMENT_TYPE_EQUALS',
                        value: ['SHIPPING_BILL']
                      }
                    ],
                    limit: 10,
                    orderBy: { modifiedDate: 'desc' },
                    bindLabel: 'documentNo',
                    bindValue: 'id',
                    displayColumns: [
                      { key: 'documentNo', header: 'Shipping Bill Number' }
                    ]
                  }
                },
                validators: [{ type: 'required', message: '' }]
              }
            }
          ]
        }
      ]
    },
    viewMode: 'new-tab',
    newTabConfig: {
      url: `documentation/export/shipping-bill/view/${REPLACE_KEY}`,
    }
  },

  IGM_ITEM_NUMBER: {
    dynamicFormConfig: {
      formRows: [
        {
          formGroups: [
            {
              style: { gridColumn: 'span 12' },
              control: {
                label: 'searchBar',
                skipLabel: true,
                displayLabel: 'Select IGM Item No.',
                disabled: false,
                placeHolder: 'Select IGM Item No.',
                returnRawValue: false,
                fieldInfo: {
                  dataType: 'picklist',
                  lookupDetails: {
                    apiUrl: 'v1/items/list',
                    filterByKeys: ['IGM_ITEM_NO_CONTAINS'],
                    additionalFilters: [
                      {
                        name: 'DOCUMENT_TYPE_EQUALS',
                        alias: 'DOCUMENT_TYPE_EQUALS',
                        value: ['BOE']
                      }
                    ],
                    limit: 10,
                    orderBy: { modifiedDate: 'desc' },
                    bindLabel: 'importCargoMetadata.igmItemNo',
                    bindValue: 'id',
                    displayColumns: [
                      { key: 'importCargoMetadata.igmItemNo', header: 'IGM Item Number' }
                    ]
                  }
                },
                validators: [{ type: 'required', message: '' }]
              }
            }
          ]
        }
      ]
    },
    viewMode: 'new-tab',
    newTabConfig: {
      url: `documentation/import/boe-filing/view/${REPLACE_KEY}`
    }
  },

  BOE_NUMBER: {
    dynamicFormConfig: {
      formRows: [
        {
          formGroups: [
            {
              style: { gridColumn: 'span 12' },
              control: {
                label: 'searchBar',
                skipLabel: true,
                displayLabel: 'Select BOE No.',
                disabled: false,
                placeHolder: 'Select BOE No.',
                returnRawValue: false,
                fieldInfo: {
                  dataType: 'picklist',
                  lookupDetails: {
                    apiUrl: 'v1/items/list',
                    filterByKeys: ['DOCUMENT_NO_CONTAINS'],
                    additionalFilters: [
                      {
                        name: 'DOCUMENT_TYPE_EQUALS',
                        alias: 'DOCUMENT_TYPE_EQUALS',
                        value: ['BOE']
                      }
                    ],
                    limit: 10,
                    orderBy: { modifiedDate: 'desc' },
                    bindLabel: 'documentNo',
                    bindValue: 'id',
                    displayColumns: [
                      { key: 'documentNo', header: 'Document No' }
                    ]
                  }
                },
                validators: [{ type: 'required', message: '' }]
              }
            }
          ]
        }
      ]
    },
    viewMode: 'new-tab',
    newTabConfig: {
      url: `documentation/import/boe-filing/view/${REPLACE_KEY}`
    }
  },

  EX_BOE_NUMBER: {
    dynamicFormConfig: {
      formRows: [
        {
          formGroups: [
            {
              style: { gridColumn: 'span 12' },
              control: {
                label: 'searchBar',
                skipLabel: true,
                displayLabel: 'Select Ex BOE No.',
                disabled: false,
                placeHolder: 'Select Ex BOE No.',
                returnRawValue: false,
                fieldInfo: {
                  dataType: 'picklist',
                  lookupDetails: {
                    apiUrl: 'v1/items/list',
                    filterByKeys: ['DOCUMENT_NO_CONTAINS'],
                    additionalFilters: [
                      {
                        name: 'DOCUMENT_TYPE_EQUALS',
                        alias: 'DOCUMENT_TYPE_EQUALS',
                        value: ['EX_BOE']
                      }
                    ],
                    limit: 10,
                    orderBy: { modifiedDate: 'desc' },
                    bindLabel: 'documentNo',
                    bindValue: 'id',
                    displayColumns: [
                      { key: 'documentNo', header: 'Document No' }
                    ]
                  }
                },
                validators: [{ type: 'required', message: '' }]
              }
            }
          ]
        }
      ]
    },
    viewMode: 'new-tab',
    newTabConfig: {
      url: `documentation/bond/ex-boe-filing/view/${REPLACE_KEY}`
    }
  },

  BL_NUMBER: {
    dynamicFormConfig: {
      formRows: [
        {
          formGroups: [
            {
              style: { gridColumn: 'span 12' },
              control: {
                label: 'searchBar',
                skipLabel: true,
                displayLabel: 'Select BL Number',
                disabled: false,
                placeHolder: 'Enter BL Number',
                fieldInfo: { dataType: 'text' },
                validators: [{ type: 'required', message: '' }]
              }
            }
          ]
        }
      ]
    },
    preSetFilter: {
      name: 'DOCUMENT_SEARCH',
      alias: 'DOCUMENT_SEARCH',
      operator: 'EQUALS',
      value: ['']
    },
    viewMode: 'new-tab',
    newTabConfig: {
      url: `manage-inventory/containers`,
      queryParams: {
        configName: "BL_NUMBER",
        value: `${REPLACE_KEY}`
      }
    }
  },

  VIA_NUMBER: {
    dynamicFormConfig: {
      formRows: [
        {
          formGroups: [
            {
              style: { gridColumn: 'span 12' },
              control: {
                label: 'searchBar',
                skipLabel: true,
                displayLabel: 'Select Via Number',
                disabled: false,
                placeHolder: 'Select Via Number',
                returnRawValue: false,
                fieldInfo: {
                  dataType: 'picklist',
                  lookupDetails: {
                    apiUrl: 'v1/vessel-port-train-details/list',
                    filterByKeys: ['VIA_NO_CONTAINS'],
                    additionalFilters: [
                      {
                        name: 'IS_ACTIVE',
                        alias: 'active',
                        operator: 'EQ',
                        value: ['true']
                      }
                    ],
                    limit: 10,
                    orderBy: { viaNo: 'asc' },
                    bindLabel: 'viaNo',
                    bindValue: 'id',
                    displayColumns: [
                      { key: 'viaNo', header: 'VIA Number' }
                    ]
                  }
                },
                validators: [{ type: 'required', message: '' }]
              }
            }
          ]
        }
      ]
    },
    preSetFilter: {
      name: 'VESSEL_EQUALS',
      alias: 'VESSEL_EQUALS',
      operator: 'EQUALS',
      value: ['']
    },
    viewMode: 'new-tab',
    newTabConfig: {
      url: `manage-inventory/containers`,
      queryParams: {
        configName: "VIA_NUMBER",
        value: `${REPLACE_KEY}`
      }
    }
  }
};
